import React from 'react';
import VoxelText from '../../components/voxel/Text/VoxelText';

export interface ColorsBoardProps { }

const ColorSquare: React.FC<any> = (props) => {
  return (
    <div className="flex flex-row gap-3 items-center">
      <div className={`h-6 w-6 rounded-md ${props.color}`} />
      <VoxelText>{props.name}</VoxelText>
    </div>
  );
};

export const ColorsBoard: React.FC<ColorsBoardProps> = ({ }) => {
  return (
    <div className='flex flex-col gap-16'>
      <div className="flex flex-col gap-6">

        <VoxelText variant='bread-semibold'>Accent colors</VoxelText>
        <div className='grid grid-cols-12 gap-y-8'>

          <VoxelText variant='bread-normal' color='dark'>purple</VoxelText>
          <ColorSquare name='50' color='bg-purple-50' />
          <ColorSquare name='100' color='bg-purple-100' />
          <ColorSquare name='200' color='bg-purple-200' />
          <ColorSquare name='300' color='bg-purple-300' />
          <ColorSquare name='400' color='bg-purple-400' />
          <ColorSquare name='500' color='bg-purple-500' />
          <ColorSquare name='600' color='bg-purple-600' />
          <ColorSquare name='700' color='bg-purple-700' />
          <ColorSquare name='800' color='bg-purple-800' />
          <ColorSquare name='900' color='bg-purple-900' />
          <ColorSquare name='950' color='bg-purple-950' />

          <VoxelText variant='bread-normal' color='dark'>violet</VoxelText>
          <ColorSquare name='50' color='bg-violet-50' />
          <ColorSquare name='100' color='bg-violet-100' />
          <ColorSquare name='200' color='bg-violet-200' />
          <ColorSquare name='300' color='bg-violet-300' />
          <ColorSquare name='400' color='bg-violet-400' />
          <ColorSquare name='500' color='bg-violet-500' />
          <ColorSquare name='600' color='bg-violet-600' />
          <ColorSquare name='700' color='bg-violet-700' />
          <ColorSquare name='800' color='bg-violet-800' />
          <ColorSquare name='900' color='bg-violet-900' />
          <ColorSquare name='950' color='bg-violet-950' />

          <VoxelText variant='bread-normal' color='dark'>indigo</VoxelText>
          <ColorSquare name='50' color='bg-indigo-50' />
          <ColorSquare name='100' color='bg-indigo-100' />
          <ColorSquare name='200' color='bg-indigo-200' />
          <ColorSquare name='300' color='bg-indigo-300' />
          <ColorSquare name='400' color='bg-indigo-400' />
          <ColorSquare name='500' color='bg-indigo-500' />
          <ColorSquare name='600' color='bg-indigo-600' />
          <ColorSquare name='700' color='bg-indigo-700' />
          <ColorSquare name='800' color='bg-indigo-800' />
          <ColorSquare name='900' color='bg-indigo-900' />
          <ColorSquare name='950' color='bg-indigo-950' />
        </div>

        <VoxelText variant='bread-semibold'>Signal colors</VoxelText>
        <div className='grid grid-cols-12 gap-y-8'>
          <VoxelText variant='bread-normal' color='dark'>info/sky</VoxelText>
          <ColorSquare name='50' color='bg-info-50' />
          <ColorSquare name='100' color='bg-info-100' />
          <ColorSquare name='200' color='bg-info-200' />
          <ColorSquare name='300' color='bg-info-300' />
          <ColorSquare name='400' color='bg-info-400' />
          <ColorSquare name='500' color='bg-info-500' />
          <ColorSquare name='600' color='bg-info-600' />
          <ColorSquare name='700' color='bg-info-700' />
          <ColorSquare name='800' color='bg-info-800' />
          <ColorSquare name='900' color='bg-info-900' />
          <ColorSquare name='950' color='bg-info-950' />

          <VoxelText variant='bread-normal' color='dark'>success/emerald</VoxelText>
          <ColorSquare name='50' color='bg-success-50' />
          <ColorSquare name='100' color='bg-success-100' />
          <ColorSquare name='200' color='bg-success-200' />
          <ColorSquare name='300' color='bg-success-300' />
          <ColorSquare name='400' color='bg-success-400' />
          <ColorSquare name='500' color='bg-success-500' />
          <ColorSquare name='600' color='bg-success-600' />
          <ColorSquare name='700' color='bg-success-700' />
          <ColorSquare name='800' color='bg-success-800' />
          <ColorSquare name='900' color='bg-success-900' />
          <ColorSquare name='950' color='bg-success-950' />

          <VoxelText variant='bread-normal' color='dark'>warning/yellow</VoxelText>
          <ColorSquare name='50' color='bg-warning-50' />
          <ColorSquare name='100' color='bg-warning-100' />
          <ColorSquare name='200' color='bg-warning-200' />
          <ColorSquare name='300' color='bg-warning-300' />
          <ColorSquare name='400' color='bg-warning-400' />
          <ColorSquare name='500' color='bg-warning-500' />
          <ColorSquare name='600' color='bg-warning-600' />
          <ColorSquare name='700' color='bg-warning-700' />
          <ColorSquare name='800' color='bg-warning-800' />
          <ColorSquare name='900' color='bg-warning-900' />
          <ColorSquare name='950' color='bg-warning-950' />

          <VoxelText variant='bread-normal' color='dark'>error/red</VoxelText>
          <ColorSquare name='50' color='bg-error-50' />
          <ColorSquare name='100' color='bg-error-100' />
          <ColorSquare name='200' color='bg-error-200' />
          <ColorSquare name='300' color='bg-error-300' />
          <ColorSquare name='400' color='bg-error-400' />
          <ColorSquare name='500' color='bg-error-500' />
          <ColorSquare name='600' color='bg-error-600' />
          <ColorSquare name='700' color='bg-error-700' />
          <ColorSquare name='800' color='bg-error-800' />
          <ColorSquare name='900' color='bg-error-900' />
          <ColorSquare name='950' color='bg-error-950' />

          <VoxelText variant='bread-normal' color='dark'>disabled/slate</VoxelText>
          <ColorSquare name='50' color='bg-slate-50' />
          <ColorSquare name='100' color='bg-slate-100' />
          <ColorSquare name='200' color='bg-slate-200' />
          <ColorSquare name='300' color='bg-slate-300' />
          <ColorSquare name='400' color='bg-slate-400' />
          <ColorSquare name='500' color='bg-slate-500' />
          <ColorSquare name='600' color='bg-slate-600' />
          <ColorSquare name='700' color='bg-slate-700' />
          <ColorSquare name='800' color='bg-slate-800' />
          <ColorSquare name='900' color='bg-slate-900' />
          <ColorSquare name='950' color='bg-slate-950' />
        </div>
        <div className='grid grid-cols-4 gap-y-8 '>
          <VoxelText variant='bread-semibold'>Voxel logo / marketing page</VoxelText>
          <VoxelText variant='bread-normal' color='dark'>Voxel green</VoxelText>
          <ColorSquare name='#8dc3ae' color='bg-voxel-green' />
          <ColorSquare name='Emerald 600/50' color='bg-success-600/50' />
          <ColorSquare name='600/60' color='bg-success-600/60' />

          <VoxelText variant='bread-normal' color='dark'>Voxel orange</VoxelText>
          <ColorSquare name='#e5b975' color='bg-voxel-orange' />
          <ColorSquare name='Yellow 600/60' color='bg-warning-600/60' />
          <ColorSquare name='600/70' color='bg-warning-600/70' />

          <VoxelText variant='bread-normal' color='dark'>Light blue</VoxelText>
          <ColorSquare name='#c7dee3' color='bg-light-blue' />
          <ColorSquare name='Sky 600/20' color='bg-info-600/20' />
          <ColorSquare name='600/30' color='bg-info-600/30' />

          <VoxelText variant='bread-normal' color='dark'>Voxel blue</VoxelText>
          <ColorSquare name='#353f4e' color='bg-voxel-blue' />
          <ColorSquare name='Slate 800/90' color='bg-slate-800/90' />
          <ColorSquare name='800/80' color='bg-slate-800/80' />

        </div>
      </div>
    </div>
  );
};

export default ColorsBoard;
